var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [_vm._v(" HTML ")]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_html.title.$error } },
        [
          _c("label", [_vm._v(" HTML Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "HTML Title" },
            model: {
              value: _vm.$v.data_html.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_html.title, "$model", $$v)
              },
              expression: "$v.data_html.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("quill-editor", {
        ref: "myQuillEditor",
        attrs: { options: _vm.editorOption },
        model: {
          value: _vm.data_html.html,
          callback: function($$v) {
            _vm.$set(_vm.data_html, "html", $$v)
          },
          expression: "data_html.html"
        }
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeHtml }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveHtml } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bbc6548", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bbc6548","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jHtmlSetup.vue
// module id = null
// module chunks = 